<div class="container mx-auto mt-8 ">
  <!-- ServiceCase Overview Component -->
  <div>
    <div class="grid sm:grid-cols-2 grid-cols-1">
      <!-- Title Section -->
      <div class="col-span-1 md:mb-0 mb-3">
        <h1 class="font-['Apex_Rounded_Medium'] lg:text-3xl text-xl">{{ "serviceCase.title" | translate }}</h1>
        <!-- Section Title -->
      </div>
      <!-- Button Section -->
      <div class="col-span-1 lg:text-end text-center text-sm lg:mb-0 lg-3">
        <a href="https://service.acp-gruppe.com/csm?id=csm_login" target="_blank" pButton pRipple
          [label]="'serviceCase.switchToServiceNow' | translate" icon="pi pi-external-link"
          class="lg:w-auto w-full lg:mr-3 lg:mb-0 mb-3">
        </a>
        <!-- GATE-615: CSM link was conditional on csmStatus().isPortalUser, with this "unlock now" button for
             everyone else. Hidden until the CSM provisioning is released to prod; the link above stays always visible.
        @if (csmStatus(); as status) {
          @if (status.isPortalUser) {
            <a href="https://service.acp-gruppe.com/csm?id=csm_login" target="_blank" pButton pRipple
              [label]="'serviceCase.switchToServiceNow' | translate" icon="pi pi-external-link"
              class="lg:w-auto w-full lg:mr-3 lg:mb-0 mb-3">
            </a>
          } @else {
            <button pButton pRipple
              [label]="(isUnlocking() ? 'serviceCase.unlocking' : 'serviceCase.unlockNow') | translate"
              icon="pi pi-lock-open"
              [loading]="isUnlocking()"
              [disabled]="isUnlocking()"
              (click)="unlockCsm()"
              class="lg:w-auto w-full lg:mr-3 lg:mb-0 mb-3">
            </button>
          }
        }
        -->
        <!-- <button pButton pRipple [label]="'serviceCase.openNewCaseButton' | translate" class="p-button-danger lg:w-auto w-full"></button> -->
      </div>
    </div>
    <!-- Grid Layout for ServiceCase Details -->
    <div class="grid xl:grid-cols-8 sm:grid-cols-6 grid-cols-4 text-sm mt-3">
      <!-- Location Information -->
      <div class="col-span-2 md:mb-0 mb-3">
        <p class="text-primary">
          {{ "serviceCase.locationLabel" | translate }}
        </p>
        <!-- Label for Location -->
        <p>{{ location() }}</p>
        <!-- Display Location Information -->
      </div>
      <!-- Personal Customer Advisor Information -->
      <div class="col-span-2 md:mb-0 mb-3">
        <p class="text-primary">
          {{ "serviceCase.advisorLabel" | translate }}
        </p>
        <!-- Label for Customer Advisor -->
        <p>{{ advisor()?.name ?? "-" }}</p>
        <!-- Display Customer Advisor's Name -->
      </div>
    </div>
  </div>
  <div class="grid lg:grid-cols-4 md:grid-cols-4 grid-cols-2 xl:text-base text-sm mt-3 gap-5 mt-8">
      <!-- Only show service case cards if user has permission to view service cases -->
      @if (canViewServiceCases()) {
        <!-- User Service Cases Card - show if user can view their own cases -->
        
          <div class="lg:col-span-2 md:col-span-2 col-span-1 md:mb-0 mb-3 card text-center h-52"
            style="padding: 2.5em 1.25em">
            @if (!isLoading()) {
            <h2 class="lg:text-3xl md:text-2xl text-xl font-bold">
              {{ userIncident() }}
            </h2>
            } @else {
            <p-skeleton width="2rem" height="1rem" class="m-auto"></p-skeleton>
            }
            <p class="md:text-base text-xs mt-3">{{ "serviceCase.myOpenCase" | translate }}</p>
            <div class="mt-5">
              <a class="icon-with-circle" (click)="isShowingAllCases.set(false)">
                <i class="pi pi-angle-right"></i>
              </a>
            </div>
          </div>

        <!-- Customer Service Cases Card - show if user can view all cases -->
    
          <div class="lg:col-span-2 md:col-span-2 col-span-1 md:mb-0 mb-3 card text-center h-52"
            style="padding: 2.5em 1.25em">
            @if (!isLoading()) {
            <h2 class="lg:text-3xl md:text-2xl text-xl font-bold">
              {{ customerIncident() }}
            </h2>
            } @else {
              <p-skeleton width="2rem" height="1rem"  class="m-auto"></p-skeleton>
                  }
            <p class="md:text-base text-xs mt-3">{{ "serviceCase.totalCase" | translate }}</p>
           @if (canViewAllServiceCases()) {            
            <div class="mt-5">
              <a class="icon-with-circle"  (click)="isShowingAllCases.set(true)">
                <i class="pi pi-angle-right"></i>
              </a>
            </div>
            }
          </div>
        }
      
  </div>
   <div class="mt-5">
    <!-- Only show service case tables if user has permission -->
    
      <p-panel [showHeader]="false">
        @if(isShowingAllCases() && canViewAllServiceCases() ) {
          <gate-customer-case-table></gate-customer-case-table>
        } @else if (canViewServiceCases() ) {
          <gate-user-case-table></gate-user-case-table>
        }
      </p-panel>
  </div>
</div>
